import React, { ChangeEvent, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux-store/store";
import { Button, TextareaAutosize, TextField } from "@mui/material";
import { getTariffs, updateTariff } from "../../redux-store/tariffs-reducer";

export const TariffsAdmin = () => {
  const dispatch = useAppDispatch();
  const tariffs = useAppSelector((state) => state.tariffsReducer.data) || [];
  const [editId, setEditId] = useState<string | null>(null);
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [price, setPrice] = useState<string>("");
  const [oldPrice, setOldPrice] = useState<string>("");
  const [longDescription, setLongDescription] = useState<string>("");

  useEffect(() => {
    dispatch(getTariffs());
  }, []);

  const onEditClick = (id: string, tName: string, tDescription: string, tPrice: number, tOldPrice: number | null, tLongDescription?: string) => {
    setEditId(id);
    setName(tName);
    setDescription(tDescription || "");
    setPrice(String(tPrice));
    setOldPrice(tOldPrice ? String(tOldPrice) : "");
    setLongDescription(tLongDescription || "");
  };

  const onSaveClick = (id: string) => {
    dispatch(updateTariff({
      id,
      name,
      description,
      longDescription,
      price: Number(price),
      oldPrice: oldPrice ? Number(oldPrice) : null,
    }));
    setEditId(null);
  };

  const onCancelClick = () => {
    setEditId(null);
  };

  const renderCard = (t: any) => (
        <div
          key={t._id}
          style={{
            border: "1px solid #ccc",
            borderRadius: 8,
            padding: 16,
            marginBottom: 16,
          }}
        >
          {editId === t._id ? (
            <React.Fragment>
              <div style={{ marginBottom: 10 }}>
                <span>Название</span>
                <TextField
                  fullWidth
                  value={name}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.currentTarget.value)}
                />
              </div>
              {t.type === "education" ? (
                <div style={{ marginBottom: 10 }}>
                  <span>Описание большая карточка (основной блок вверху страницы). Пункты разделяйте знаком ; . Для жирного текста оборачивайте его в две звёздочки: **текст**. Чтобы сделать пустую строку-отступ, поставьте два знака ;; подряд. Чтобы строку по центру, поставьте перед ней знак ^</span>
                  <TextareaAutosize
                    style={{ width: "100%" }}
                    minRows={6}
                    value={longDescription}
                    onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setLongDescription(e.currentTarget.value)}
                  />
                </div>
              ) : null}
              <div style={{ marginBottom: 10 }}>
                <span>Описание маленькая карточка снизу (разделяйте пункты знаком ;)</span>
                <TextareaAutosize
                  style={{ width: "100%" }}
                  minRows={3}
                  value={description}
                  onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setDescription(e.currentTarget.value)}
                />
              </div>
              <div style={{ marginBottom: 10 }}>
                <span>Цена (руб.)</span>
                <TextField
                  fullWidth
                  type="number"
                  value={price}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => setPrice(e.currentTarget.value)}
                />
              </div>
              <div style={{ marginBottom: 10 }}>
                <span>Старая цена (для зачёркнутой цены, необязательно)</span>
                <TextField
                  fullWidth
                  type="number"
                  value={oldPrice}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => setOldPrice(e.currentTarget.value)}
                />
              </div>
              <Button
                variant={"contained"}
                onClick={() => onSaveClick(t._id)}
                style={{ marginRight: 10 }}
              >
                Сохранить
              </Button>
              <Button variant={"outlined"} onClick={onCancelClick}>
                Отмена
              </Button>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div style={{ fontWeight: "bold", fontSize: 18 }}>{t.name}</div>
              <div style={{ margin: "8px 0", whiteSpace: "pre-wrap" }}>{t.description}</div>
              <div>
                Цена: <b>{t.price} руб.</b>
                {t.oldPrice ? <span style={{ marginLeft: 10, textDecoration: "line-through", color: "#888" }}>{t.oldPrice} руб.</span> : null}
              </div>
              <Button
                variant={"contained"}
                style={{ marginTop: 10 }}
                onClick={() => onEditClick(t._id, t.name, t.description, t.price, t.oldPrice, t.longDescription)}
              >
                Редактировать
              </Button>
            </React.Fragment>
          )}
        </div>
  );

  const tariffList = tariffs.filter((t: any) => t.type === "tariff");
  const educationList = tariffs.filter((t: any) => t.type === "education");

  return (
    <div style={{ padding: "20px 0" }}>
      <h2>Тарифы</h2>
      {tariffList.map((t: any) => renderCard(t))}
      <h2 style={{ marginTop: 40 }}>Обучение</h2>
      {educationList.map((t: any) => renderCard(t))}
    </div>
  );
};
